import React from 'react';
import { Box, Typography } from '@mui/material';
import { useStorefrontConfig } from '../StorefrontConfigProvider';

/**
 * AnnouncementBar
 * Thin top utility strip. Uses the store tagline as a rotating-style banner
 * message when present, otherwise a sensible default. Fully driven by config.
 */
const AnnouncementBar = () => {
  const { settings } = useStorefrontConfig();
  const message =
    settings?.store_tagline ||
    (settings?.free_shipping_threshold
      ? `Free shipping on orders above ${settings.currency_symbol || '₹'}${settings.free_shipping_threshold}`
      : '');

  if (!message) return null;

  return (
    <Box
      sx={{
        bgcolor: 'primary.main',
        color: 'primary.contrastText',
        textAlign: 'center',
        py: 0.75,
        px: 2,
      }}
    >
      <Typography variant="caption" sx={{ fontWeight: 600, letterSpacing: '0.05em' }}>
        {message}
      </Typography>
    </Box>
  );
};

export default AnnouncementBar;
